import { render } from "./CustomPageBuilder.vue?vue&type=template&id=4909d524&scoped=true"
import script from "./CustomPageBuilder.vue?vue&type=script&lang=js"
export * from "./CustomPageBuilder.vue?vue&type=script&lang=js"

import "./CustomPageBuilder.vue?vue&type=style&index=0&id=4909d524&lang=scss&scoped=true"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4909d524"]])

export default __exports__